import React, { useEffect, useRef } from 'react';
import './LogPanel.css';

const LogPanel = ({ logs }) => {
  const logEndRef = useRef(null);

  useEffect(() => {
    logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs]);

  const getLogIcon = (type) => {
    switch (type) {
      case 'success': return '?';
      case 'error': return '?';
      case 'warning': return '?';
      case 'info':
      default: return '?';
    }
  };

  return (
    <div className="log-panel">
      <div className="log-header">
        <h3>Dnevnik aktivnosti</h3>
        {logs.length > 0 && (
          <span className="log-count">{logs.length} dogodkov</span>
        )}
      </div>
      
      <div className="log-container">
        {logs.length === 0 ? (
          <div className="log-empty">
            <span className="empty-icon">??</span>
            <p>Se ni aktivnosti. Povezite se za zacetek.</p>
          </div>
        ) : (
          logs.map((log) => (
            <div key={log.id} className={`log-entry log-${log.type}`}>
              <span className="log-icon">{getLogIcon(log.type)}</span>
              <div className="log-content">
                <span className="log-timestamp">{log.timestamp}</span>
                <span className="log-message">{log.message}</span>
              </div>
            </div>
          ))
        )}
        <div ref={logEndRef} />
      </div>
    </div>
  );
};

export default LogPanel;
